import { combineReducers } from 'redux';

const pageSettings = (state = {config:{
        "API_PATH" : "https://devapi.nuggets.live/",
        "BUILDER_PATH" : "https://dev.nuggets.live/builder/index.html?",
        "PUB_PLAYER_PATH" : "https://dev.nuggets.live/publish/",
        "UNPUB_PLAYER_PATH" : "https://dev.nuggets.live/player/?",
        "IMG_PATH" : "https://s3cdn.vignets.com/",
        "IMGIX_PATH" : "https://vignets.imgix.net/",
        "BUCKET_PATH" : "https://lexplainer.s3.amazonaws.com/",
        "BUCKET_NAME" : "lexplainer",
        "REGION" : "us-east-1",
        "ALBUM_NAME" : "assets/slider",
        "ACCESS_KEY_ID" : "AKIARFKGTHVQI23WX22J",
        "SECRET_ACCESS_KEY" : "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"
    }},  action) => {

    switch(action.type){
        case "SAVE_CONFIG":
            return {
                ...state,
                config  : action.data
            }
        case "SET_PAGE":
            return {
                ...state,
                page  : action.page.name
            }
        case "GET_PAGE":
            return {
                ...state,
                page : state.page
            }
        default:
            return state;
    }
}


const userSettings = (state = {loggedin : false, loggedUserData : undefined ,loggedout : undefined, login_error :false},  action) => {

    switch(action.type){
        case "USER_LOGGEDIN":
            return {
                ...state,
                loggedin : true,
                loggedUserData : (action.loggedInUser && action.loggedInUser.data)? (action.loggedInUser.data.response) : state.loggedUserData,

            }
        case "USER_LOGGEDIN_FAILURE":
            return {
                ...state,
                loggedin : false,
                login_error : true
            }
        case "USER_LOGGEDOUT":
            return {
                ...state,
                loggedin : false,
                loggedUserData : undefined
            }
        case "USER_PSWDRESET":
            return {
                ...state
            }
        default:
            return state;
    }
}


const pages = combineReducers({
    pageSettings,
    userSettings
})

export default pages;
//export const getPageSettings = state => state.pages.pageSettings;



// WEBPACK FOOTER //
// ./src/reducers/pages.js